/** Window events for Control Centre Tasks UI (open from anywhere). */
export const ASSISTANT_OPEN_TODOS_EVENT = 'assistant:openTodos';
export const ASSISTANT_SHOW_TODO_LIST_EVENT = 'assistant:showTodoList';

export type ShowTodoListDetail = {
  listId?: string;
  listName?: string;
  /** Default open */
  status?: 'open' | 'completed' | 'all';
};

export type OpenTodosDetail = {
  /** Open the full Tasks drawer already on the edit form for this Task */
  editTodoId?: string;
};

export function openTodosUi(detail?: OpenTodosDetail): void {
  window.dispatchEvent(new CustomEvent(ASSISTANT_OPEN_TODOS_EVENT, { detail: detail || {} }));
}

export function showTodoListUi(detail: ShowTodoListDetail): void {
  window.dispatchEvent(new CustomEvent(ASSISTANT_SHOW_TODO_LIST_EVENT, { detail }));
}
